import "./Countdown.css";

/**
 * Restzeit unter dem Plattenspieler, z. B. "0:15 übrig".
 * knapp: letzte Sekunden (rot). Ohne Zeitlimit (sekunden null) nichts.
 * @category spiel
 */
export function Countdown({ sekunden, knapp = false, zusatz = "übrig" }) {
  if (sekunden === null || sekunden === undefined) return null;
  const m = Math.floor(sekunden / 60);
  const s = String(sekunden % 60).padStart(2, "0");
  return (
    <div className={`restzeit${knapp ? " knapp" : ""}`} role="timer" aria-label={`Noch ${sekunden} Sekunden`}>
      <b>
        {m}:{s}
      </b>
      <span>{sekunden > 0 ? zusatz : "Zeit um"}</span>
    </div>
  );
}

export default Countdown;
